<template>
  <div class="migration-info-page">
    <section class="content">
      <div class="content-center">
        <h2>Onze app is vernieuwd</h2>
        
        <p>
          Opdrachten vind je voortaan in onze nieuwe PIDZ app. In deze app kun je alleen nog je uren en facturen over 2025 en eerder indienen. Vergeet je facturen niet te downloaden voor je eigen administratie. Vanaf 8 januari is deze app niet meer beschikbaar.
        </p>
        
        <p>
          Onze nieuwe app is beschikbaar in de Appstore & Google Playstore.
        </p>
        
        <div class="badges">
          <a v-if="isIosOrWeb" href="https://apps.apple.com/nl/app/pidz/id6747712718"
             target="_blank" >
            <app-store-badge />
          </a>
          <a v-if="isAndroidOrWeb" href="https://play.google.com/store/apps/details?id=com.pidzsoftware.pidzzorgplatform"
             target="_blank" >
            <play-store-badge />
          </a>
        </div>
      </div>

      <div class="bottom">
        <button class="back-button" @click="goToDashboard">
          Terug naar dashboard
        </button>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import AppStoreBadge from '@app/components/AppStoreBadge.vue';
import PlayStoreBadge from '@app/components/PlayStoreBadge.vue';
import { Capacitor } from '@capacitor/core';
import { computed } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();
const isIosOrWeb = computed(() => Capacitor.getPlatform() === 'ios' || Capacitor.getPlatform() === 'web');
const isAndroidOrWeb = computed(() => Capacitor.getPlatform() === 'android' || Capacitor.getPlatform() === 'web');

const goToDashboard = () => {
  router.push({ name: 'dashboard' });
};
</script>

<style lang="scss" scoped>
.migration-info-page {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-grow: 1;

  .content {
    padding: 24px 16px;
    width: 100%;
    max-width: 600px;
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow-y: auto;

    .content-center {
      flex-grow: 1;
    }

    h2 {
      color: var(--pidz-blue);
      font-size: 24px;
      font-weight: bold;
      text-align: center;
      margin-bottom: 16px;
    }

    p {
      color: var(--pidz-black);
      font-size: 16px;
      line-height: 1.5;
      margin-bottom: 16px;
      text-align: center;
    }

    .badges {
      display: flex;
      justify-content: center;
      gap: 16px;
      margin-bottom: 32px;

      a {
        display: block;
        height: 50px;

        svg {
          height: 100%;
          width: auto;
        }
      }
    }

    .bottom {
      margin-top: auto;
      padding-bottom: calc(24px + env(safe-area-inset-bottom));

      .back-button {
        border: 0;
        font-family: inherit;
        color: var(--pidz-white);
        display: block;
        width: 100%;
        padding: 12px;
        font-size: 16px;
        background-color: var(--pidz-blue);
        text-align: center;
        border-radius: 5px;
        cursor: pointer;

        &:hover {
          opacity: 0.9;
        }
      }
    }
  }
}
</style>
